import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1186 20.482C12.1186 20.7681 11.8867 21 11.6007 21H4.65254C4.17797 21 3.78407 20.8405 3.47085 20.5214C3.15695 20.2016 3 19.8 3 19.3165V6.10791C3 5.62446 3.15695 5.22319 3.47085 4.90411C3.78407 4.58435 4.17797 4.42446 4.65254 4.42446H9.35593C9.45763 4.02734 9.66949 3.69065 9.99152 3.41439C10.3136 3.13813 10.6949 3 11.1356 3C11.5763 3 11.9617 3.13813 12.2919 3.41439C12.6227 3.69065 12.8305 4.02734 12.9153 4.42446H17.6186C18.0932 4.42446 18.4875 4.58435 18.8014 4.90411C19.1146 5.22319 19.2712 5.62446 19.2712 6.10791V11.1318C19.2712 11.4126 19.0435 11.6403 18.7627 11.6403C18.4819 11.6403 18.2542 11.4126 18.2542 11.1318V6.10791C18.2542 5.93525 18.1905 5.78435 18.063 5.65519C17.9363 5.52535 17.7881 5.46043 17.6186 5.46043H15.2034V6.10791C15.2034 6.55683 15.0424 6.94532 14.7203 7.27338C14.3983 7.60144 14.0085 7.76547 13.5508 7.76547H8.72034C8.26271 7.76547 7.87288 7.60144 7.55085 7.27338C7.22881 6.94532 7.0678 6.55683 7.0678 6.10791V5.46043H4.65254C4.48305 5.46043 4.33492 5.52535 4.20814 5.65519C4.08068 5.78435 4.01695 5.93525 4.01695 6.10791V19.3165C4.01695 19.4892 4.08068 19.6401 4.20814 19.7693C4.33492 19.8991 4.48305 19.964 4.65254 19.964H11.6007C11.8867 19.964 12.1186 20.1959 12.1186 20.482ZM14.6949 18.7209L20.1102 13.2043C20.2119 13.1007 20.3305 13.0444 20.4661 13.0355C20.6017 13.0272 20.7288 13.0835 20.8475 13.2043C20.9492 13.3079 21 13.4243 21 13.5534C21 13.6833 20.9492 13.8086 20.8475 13.9295L15.2797 19.6014C15.1102 19.7741 14.9153 19.8604 14.6949 19.8604C14.4746 19.8604 14.2797 19.7741 14.1102 19.6014L11.4407 16.8561C11.339 16.7698 11.2837 16.6531 11.2749 16.506C11.2668 16.3595 11.322 16.2345 11.4407 16.1309C11.5424 16.0273 11.661 15.9755 11.7966 15.9755C11.9322 15.9755 12.0508 16.0273 12.1525 16.1309L14.6949 18.7209ZM11.1356 5.69352C11.3729 5.69352 11.5678 5.61583 11.7203 5.46043C11.8729 5.30504 11.9492 5.10647 11.9492 4.86475C11.9492 4.62302 11.8729 4.42446 11.7203 4.26906C11.5678 4.11367 11.3729 4.03597 11.1356 4.03597C10.8983 4.03597 10.7034 4.11367 10.5508 4.26906C10.3983 4.42446 10.322 4.62302 10.322 4.86475C10.322 5.10647 10.3983 5.30504 10.5508 5.46043C10.7034 5.61583 10.8983 5.69352 11.1356 5.69352Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'support');
export default IconComponent;
